let elTableBody = ELEMENT.Table.components.TableBody;
export default {
  name: "DsfElTableBody",
  mixins: [elTableBody],
  inject: {
    $dsfElTable: {
      default: null
    }
  },
  computed: {
    fixedMark() {
      return this.getFixed(this.fixed);
    },
    table() {
      return this.$dsfElTable;
    },
    tableUseVirtulScroll() {
      return this.table.useVirtulScroll;
    }
  },
  created() {
    this.$table = this.table;
    this.table.tbodys[this.fixedMark] = this;
  },
  mounted() {
    // 监听表体尺寸变
    if (!this.table.useVirtulScroll && this.fixedMark == "main") {
      this.bodyObserver = new ResizeObserver(() => {
        this.debounceSyncRowHeight();
      });
      this.startResizeObserver();
    }
    this.debounceSyncRowHeight = _.debounce(this._syncRowHeight, 200);
  },
  methods: {
    startResizeObserver() {
      this.bodyObserver && this.bodyObserver.observe(this.$refs.body);
    },
    endResizeObserver() {
      this.bodyObserver && this.bodyObserver.unobserve(this.$refs.body);
    },
    _syncRowHeight() {
      if (!this.table.useVirtulScroll && this.fixedMark == "main" && this.data.length > 0) {
        this.syncRowHeight();
      }
    },
    syncRowHeight() {
      let heights = [];
      let tr = this.$refs.body.querySelectorAll(".el-table__row");
      tr.forEach((row, i) => {
        let index = row.getAttribute("row-index");
        row.style.height = "auto";
        let realHeight = row.getBoundingClientRect().height;
        heights.push({
          elm: row,
          index: i,
          height: realHeight
        });
      });
      let left_tr = this?.table?.$refs?.fixedBodyWrapper?.querySelectorAll?.(".el-table__row") || null;
      let right_tr = this?.table?.$refs?.rightFixedBodyWrapper?.querySelectorAll?.(".el-table__row") || null;
      //将表格主体的行高同步给左右两侧冻结区域表格行高
      _.each(heights, (h) => {
        if (left_tr && left_tr.length > 0 && left_tr[h.index]) {
          left_tr[h.index].style.height = this.unitSize(h.height);
        }
        if (right_tr && right_tr.length > 0 && right_tr[h.index]) {
          right_tr[h.index].style.height = this.unitSize(h.height);
        }
      });
    },
    getFixed(fixed) {
      if (fixed == "left" || fixed == "right") {
        return fixed;
      } else if (fixed === true) {
        return "left";
      } else {
        return "main";
      }
    },
    //重写行render函数，
    rowRender(row, $index, treeRowData) {
      const { treeIndent, columns, firstDefaultColumnIndex, table, fixedMark } = this;
      const columnsHidden = columns.map((column, index) => this.isColumnHidden(index));
      const rowClasses = this.getRowClass(row, $index);
      let display = true;
      if (treeRowData) {
        rowClasses.push("el-table__row--level-" + treeRowData.level);
        display = treeRowData.display;
      }
      // 指令 v-show 会覆盖 row-style 中 display
      // 使用 :style 代替 v-show https://github.com/ElemeFE/element/issues/16995
      let displayStyle = display
        ? null
        : {
          display: "none"
        };
      let h = this.$createElement;

      let rowStyle = {};
      let height = "";
      if (table.useVirtulScroll) {
        height = this.unitSize(this.table.minRowHeight);
      } else {
        // height = this.unitSize(table.rowHeights[$index]);
      }

      if (table.useVirtulScroll) {
        rowStyle.height = height;
      } else {
        // if (fixedMark == "left" || fixedMark == "right") {
        //   rowStyle.height = height;
        // }
      }
      //加载表格内容
      let renderColumns = columns.map((column, cellIndex) => {
        let mark = true;
        if (this.fixedMark == "left" || this.fixedMark == "right") {
          if (this.getFixed(column.fixed) != this.fixedMark) {
            mark = false;
            // return;
          }
        }
        const { rowspan, colspan } = this.getSpan(row, column, $index, cellIndex);
        if (!rowspan || !colspan) {
          return null;
        }
        const columnData = { ...column };
        columnData.realWidth = this.getColspanRealWidth(columns, colspan, cellIndex);
        const data = {
          store: this.store,
          _self: this.context || this.table.$vnode.context,
          column: columnData,
          row,
          $index
        };
        if (cellIndex === firstDefaultColumnIndex && treeRowData) {
          data.treeNode = {
            indent: treeRowData.level * treeIndent,
            level: treeRowData.level
          };
          if (typeof treeRowData.expanded === "boolean") {
            data.treeNode.expanded = treeRowData.expanded;
            // 表明是懒加载
            if ("loading" in treeRowData) {
              data.treeNode.loading = treeRowData.loading;
            }
            if ("noLazyChildren" in treeRowData) {
              data.treeNode.noLazyChildren = treeRowData.noLazyChildren;
            }
          }
        }
        let cell = h(
          "td",
          {
            style: [this.getCellStyle($index, cellIndex, row, column)],
            class: this.getCellClass($index, cellIndex, row, column),
            attrs: {
              rowspan: rowspan,
              colspan: colspan
            },
            on: {
              mouseenter: ($event) => this.handleCellMouseEnter($event, row),
              mouseleave: this.handleCellMouseLeave
            }
          },
          mark ? [this.renderCell(column, data, this.$createElement, columnsHidden, cellIndex)] : [h()]
          // [this.renderCell(column, data, this.$createElement, columnsHidden, cellIndex)]
        );
        return cell;
      });

      return h(
        "tr",
        {
          style: [displayStyle, this.getRowStyle(row, $index), rowStyle],
          class: rowClasses,
          attrs: {
            "row-index": $index
          },
          // key: $index,
          key: table.useVirtulScroll ? undefined : this.getKeyOfRow(row, $index),
          on: {
            dblclick: ($event) => this.handleDoubleClick($event, row),
            click: ($event) => this.handleClick($event, row),
            contextmenu: ($event) => this.handleContextMenu($event, row),
            mouseenter: (_) => this.handleMouseEnter($index),
            mouseleave: this.handleMouseLeave
          },
          hook: {
            // insert(vnode) {
            //   if (fixedMark == "main") {
            //     if (!table.useVirtulScroll) {
            //       let realHeight = vnode?.elm?.offsetHeight;
            //       if (table.rowHeights[$index] != realHeight) {
            //         table.$set(table.rowHeights, $index, realHeight);
            //       }
            //     }
            //   }
            // },
            // updated(oldVnode, vnode) {
            //   if (fixedMark == "main" && !this.useVirtulScroll) {
            //     let realHeight = vnode?.elm?.offsetHeight;
            //     if (table.rowHeights[$index] != realHeight) {
            //       table.$set(table.rowHeights, $index, realHeight);
            //     }
            //   }
            // }
          }
        },
        renderColumns
      );
    },
    // rowFastScrollRender(row, $index) {
    //   const { treeIndent, columns, firstDefaultColumnIndex, table, fixedMark } = this;
    //   const columnsHidden = columns.map((column, index) => this.isColumnHidden(index));
    //   const rowClasses = this.getRowClass(row, $index);
    //   let display = true;
    //   let displayStyle = display
    //     ? null
    //     : {
    //       display: "none"
    //     };
    //   let height = this.unitSize(this.table.minRowHeight);
    //   let rowHeight = { height: height };
    //   return (
    //     <tr style={[displayStyle, this.getRowStyle(row, $index), rowHeight]} class={rowClasses} row-index={$index}>
    //       <td class="el-table__cell" colspan={columns.length}></td>
    //     </tr>
    //   );
    // },
    renderCell(column, data, h, columnsHidden, cellIndex) {
      return column.renderCell.call(this._renderProxy, h, data, columnsHidden[cellIndex]);
    }
  },
  updated() {
    // console.log("update-tbody");
  },
  beforeDestroy() {
    delete this.$table.tbodys[this.fixedMark];
    delete this.$table;
    this.bodyObserver && this.bodyObserver.disconnect();
  },
  render(h) {
    const data = this.data || [];
    let acc = [];
    let rows = [];
    if (this.table.useVirtulScroll) {
      _.each(this.data || [], (row, i) => {
        if (i >= this.table.startIndex && i <= this.table.endIndex) {
          let rowVnode = this.wrappedRowRender(row, i);
          rows.push(rowVnode);
        }
      });
    } else {
      rows = this.data.reduce((acc, row) => {
        let rowVnode = this.wrappedRowRender(row, acc.length);
        return acc.concat(rowVnode);
      }, []);
    }
    let vnodes = (
      <table class="el-table__body" cellspacing="0" cellpadding="0" border="0">
        <colgroup>
          {this.columns.map((column) => (
            <col name={column.id} key={column.id} />
          ))}
        </colgroup>
        <tbody ref="body">
          {rows}
          {/* <el-tooltip effect={this.table.tooltipEffect} placement="top" ref="tooltip" content={this.tooltipContent}></el-tooltip> */}
        </tbody>
      </table>
    );
    // if (this.fixedMark == "main") {
    //   this.$nextTick(() => {
    //     this.table.doLayoutUpdateRowHeight();
    //   });
    // }
    return vnodes;
  }
};
